module.exports = __webpack_public_path__ + "img/sequence-miyashita-park@2x.8dc1882c.jpg";